import { IconTypes } from "./svg-icon.model";

export interface PathStep {
  active: boolean;
  completed: boolean;
  disabled: boolean;
  icon?: IconTypes;
  label?: string;
  name: FlowPathEnum;
}

/**
 * Router paths (sans 'book/') for the application
 * pages.
 *
 * The order of navigation is set up by the ByOrder
 * property. Navigation order is independent of step
 * order.
 */
export enum FlowPathEnum {
  SEARCH = '',
  FLIGHTS = 'flights',
  BAGS = 'bags',
  SEATS = 'seats',
  MEALS = 'meals',
  EXTRAS = 'extras',
  TRAVELERS = 'travelers',
  PAYMENT = 'payment',
  REVIEW = 'review',
  PROCESSING = 'processing',
  CONFIRMATION = 'confirmation',
  TRIP_DETAILS = 'trip-details',
  FLIGHT_STATUS = 'flight-status',
  DOCUMENTS = 'documents',
  BOARDING_PASS = 'boarding-pass',
  HOME = 'home',
  RECEIPT = 'receipt',
  ACCOUNT = 'account',
}

export const HIDDEN_TRIP_SUMMARY_PATHS = [
  FlowPathEnum.PAYMENT,
  FlowPathEnum.REVIEW,
  FlowPathEnum.CONFIRMATION,
  FlowPathEnum.BOARDING_PASS,
  FlowPathEnum.RECEIPT,
];

export const HIDDEN_TRIP_SUMMARY_PATHS_FOR_EXP_837 = [
  FlowPathEnum.REVIEW,
  FlowPathEnum.CONFIRMATION,
  FlowPathEnum.BOARDING_PASS,
  FlowPathEnum.RECEIPT,
];
